import { render, staticRenderFns } from "./QPromotionTracker2.vue?vue&type=template&id=544509f6&scoped=true&"
import script from "./QPromotionTracker2.vue?vue&type=script&lang=js&"
export * from "./QPromotionTracker2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544509f6",
  null
  
)

export default component.exports